import { render } from "./GoodsAddView.vue?vue&type=template&id=f6b10ad6"
import script from "./GoodsAddView.vue?vue&type=script&lang=js"
export * from "./GoodsAddView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__